import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { QRCodeModule } from 'angularx-qrcode';

import { GeneralModule } from '../general/general.module';
import { WalletBalanceComponent } from './wallet-balance/wallet-balance.component';
import { CryptoAddressComponent } from './crypto-address/crypto-address.component';
import { CryptoTransactionAgreementsComponent } from './crypto-transaction-agreements/crypto-transaction-agreements.component';
import { DropdownComponent } from './dropdown/modal-dropdown.component';
import { OtpModalComponent } from './otp-modal/otp-modal.component';
import { AddBankComponent } from './add-bank/add-bank/add-bank.component';
import { BankDetailsFormComponent } from './add-bank/bank-details-form/bank-details-form.component';
import { BankDetailsComponent } from './add-bank/bank-details/bank-details.component';
import { BankIbanFormComponent } from './add-bank/bank-iban-form/bank-iban-form.component';
import { SignedNumberComponent } from './signed-number/signed-number.component';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  declarations: [
    WalletBalanceComponent,
    CryptoAddressComponent,
    CryptoTransactionAgreementsComponent,
    DropdownComponent,
    OtpModalComponent,
    AddBankComponent,
    BankIbanFormComponent,
    BankDetailsFormComponent,
    BankDetailsComponent,
    SignedNumberComponent,
  ],
  imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        GeneralModule,
        QRCodeModule,
        MatSlideToggleModule,
        PipesModule
    ],
  exports: [
    WalletBalanceComponent,
    CryptoAddressComponent,
    CryptoTransactionAgreementsComponent,
    DropdownComponent,
    OtpModalComponent,
    AddBankComponent,
    SignedNumberComponent,
  ]
})
export class SharedModule { }
